import { createTableColumn } from "@fluentui/react-components";
import { ExpandedColumn } from "library/types/columns";
import { useTranslation } from "react-i18next";
import { useGetTaxonomies } from "state/queries/useGetTaxonomies";

export const useTransformColumns = (defaultCols: ExpandedColumn[]) => {
  const { data: taxonomy } = useGetTaxonomies();
  const { t } = useTranslation();
  if (!taxonomy) return [];
  return defaultCols.map((col) =>
    createTableColumn({
      columnId: col.key,
      renderHeaderCell: () => t(col.labelKey) || "",
      renderCell: (item: any) => {
        const row = item; // Assuming `item` represents a row
        if (
          col.detailsListColumn({
            t,
            taxonomy: taxonomy as any,
            width: row.width,
          }).render
        ) {
          return col
            .detailsListColumn({
              t,
              taxonomy: taxonomy as any,
              width: row.width,
            })
            .render({ row });
        }
        if (
          col.detailsListColumn({
            t,
            taxonomy: taxonomy as any,
            width: row.width,
          })?.transform
        ) {
          return col
            .detailsListColumn({
              t,
              taxonomy: taxonomy as any,
              width: row.width,
            })
            .transform({ row });
        }
        return row[col.key] || null;
      },
    })
  );
};
